import styled from 'styled-components';

import { AppCtas } from './AppCtas';
import { AppRating } from './AppRating';

export const DownloadCta = () => (
  <DownloadCta.Content>
    <DownloadCta.Width>
      <AppRating />
      <AppCtas />
    </DownloadCta.Width>
  </DownloadCta.Content>
);

DownloadCta.Content = styled.div`
  color: ${({ theme }) => theme.colors.darkGray};
  margin-top: 28px;
`;
DownloadCta.Width = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
DownloadCta.Heading = styled.h1`
  font-size: 24px;
  line-height: 32px;
  margin: 0 0 16px;
  text-align: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    margin: 0 0 24px;
    font-size: 32px;
    line-height: 44px;
  }
`;
